import Layout from '@/layouts/EmptyLayout'
export default [{
    path: '/penalties',
    name: 'penalties',
    meta: {
      layout: 'main'
    },
  component: () => import('@/views/penalties/index')
    
  }]
